import React from 'react'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import styled from '@emotion/styled'
import {
  Box,
  Button,
  Checkbox,
  Paper,
  Typography,
  Menu,
  IconButton,
  Grid,
  Chip
} from '@mui/material'
import { ReactComponent as DownloadComponent } from '../../assets/download.svg'
import { ReactComponent as CopyComponent } from '../../assets/copy.svg'
import { ReactComponent as InfoDealStatusComponent } from '../../assets/info menu.svg'
import { STATUS_CURRENCY_PAIR } from '../../utils/constants'

export const PaperStyle = styled(Paper)(({ theme }) => {
  return {
    boxShadow: 'none',
    minHeight: 0,
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 8px',
    border: '0px',
    backgroundColor: 'transparent'
  }
})

export const ButtonGroupTrade = styled(Button)(({ theme }) => {
  return {
    border: `1px solid #FEE274`,
    borderRadius: '3px',
    backgroundColor: theme.palette.tabs.backgroundColor.hover,
    color: '#FEE274',
    fontFamily: 'Nunito',
    fontSize: '14px',
    height: '32px',
    padding: '11px 24px',
    textTransform: 'capitalize',
    '&:hover': {
      border: `1px solid #E6C860`,
      color: '#E6C860',
      backgroundColor: theme.palette.tabs.backgroundColor.hover
    },
    '&:disabled': {
      border: `1px solid ${theme.palette.button.disable}`,
      color: theme.palette.svg.clearIcon
    }
  }
})

export const ButtonStatus = styled(Button)(({ theme }) => {
  return {
    border: `none`,
    borderRadius: '3px',
    backgroundColor: '#39394E',
    color: '#A4A4FF',
    fontFamily: 'Nunito',
    fontSize: '14px',
    height: '32px',
    padding: '11px 24px',
    textTransform: 'capitalize',
    '&:hover': {
      border: `none`,
      color: '#A4A4FF',
      backgroundColor: '#39394E'
    },
    '&:disabled': {
      border: `1px solid ${theme.palette.button.disable}`,
      color: theme.palette.svg.clearIcon
    }
  }
})

export const ButtonAmendTrade = styled(Button)(({ theme }) => {
  return {
    backgroundColor: theme.palette.button.edit.primary,
    borderRadius: '3px',
    padding: '11px 24px',
    color: 'black',
    height: '32px',
    fontSize: '14px',
    fontFamily: 'Nunito',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.button.edit.hover
    },
    '&:disabled': {
      background: theme.palette.button.disable,
      color: theme.palette.svg.clearIcon
    }
  }
})

export const ButtonAllocate = styled(Button)(({ theme }) => {
  return {
    borderRadius: '3px',
    padding: '11px 24px',
    backgroundColor: '#39394E',
    color: '#A4A4FF',
    height: '32px',
    fontSize: '14px',
    fontFamily: 'Nunito',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#4C4C66',
      color: '#BEBEFF'
    },
    '&:disabled': {
      background: theme.palette.button.disable,
      color: theme.palette.svg.clearIcon
    }
  }
})

export const ButtonGiveUp = styled(Button)(({ theme }) => {
  return {
    border: `1px solid #60A8FF`,
    borderRadius: '3px',
    backgroundColor: theme.palette.tabs.backgroundColor.hover,
    padding: '11px 24px',
    color: '#60A8FF',
    height: '32px',
    fontSize: '14px',
    fontFamily: 'Nunito',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.tabs.backgroundColor.hover,
      color: '#4A98E6',
      border: `1px solid #4A98E6`
    },
    '&:disabled': {
      color: theme.palette.svg.clearIcon,
      border: `1px solid ${theme.palette.button.disable}`
    }
  }
})

export const ButtonDeleted = styled(Button)(({ theme }) => {
  return {
    backgroundColor: theme.palette.button.delete.primary,
    padding: '11px 24px',
    color: 'black',
    borderColor: theme.palette.button.delete.primary,
    borderRadius: '3px',
    height: '32px',
    fontSize: '14px',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Nunito',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.button.delete.hover
    },
    '&:disabled': {
      background: theme.palette.button.disable,
      color: theme.palette.svg.clearIcon
    }
  }
})

export const ButtonReview = styled(Button)(({ theme, press }) => {
  let border = `1px solid #FD7557`
  let backgroundColor = 'transparent'
  if (press === 'true') {
    border = `1px solid #FD7557`
    backgroundColor = '#5A3834'
  }
  return {
    border: border,
    backgroundColor: backgroundColor,
    borderRadius: '2px',
    padding: '11px 16px',
    color: '#FD7557',
    height: '32px',
    fontSize: '14px',
    fontFamily: 'Nunito',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#5A3834',
      color: '#E65C42',
      border: border
    },
    '&:disabled': {
      border: '1px solid  #707079',
      color: '#BABEC7',
      borderRadius: '2px'
    }
  }
})

export const ButtonCsv = styled(Button)(() => {
  return {
    border: '#264A35',
    backgroundColor: '#264A35',
    borderRadius: '2px',
    padding: '11px 16px',
    color: '#2BDF68',
    height: '32px',
    fontSize: '14px',
    fontFamily: 'Nunito',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#1e3b2b',
      color: '#2BDF68',
      border: '#1e3b2b'
    },
    '&:disabled': {
      border: '1px solid  #707079',
      color: '#BABEC7',
      borderRadius: '2px'
    }
  }
})

export const ButtonClearFilter = styled(Button)(() => {
  let border = `1px solid #A4A4FF`
  let backgroundColor = 'transparent'

  return {
    border: border,
    backgroundColor: backgroundColor,
    borderRadius: '3px',
    padding: '11px 16px',
    color: '#A4A4FF',
    height: '32px',
    fontSize: '14px',
    fontFamily: 'Nunito',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#8C8CFF',
      border: border,
      borderColor: '#8C8CFF'
    }
  }
})

export const CheckboxTradeBlotter = styled(Checkbox)(({ theme, insideDeal }) => {
  let color = theme.palette.separators.primary
  let backgroundColor = theme.palette.separators.primary
  if (!isNaN(insideDeal)) {
    color = backgroundColor = '#242428'
  }

  return {
    position: 'absolute',
    top: 0,
    left: 0,
    '& .MuiSvgIcon-root': {
      color,
      backgroundColor,
      border: `${theme.palette.button.save.primary}`,
      borderRadius: '2px'
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      color: `${theme.palette.button.save.primary} `,
      borderColor: `${theme.palette.button.save.primary}`,
      borderRadius: '2px'
    },
    '&.Mui-disabled svg path': {
      fill: 'none !important'
    }
  }
})

export const CheckboxTradeBlotterHeader = styled(Checkbox)(({ theme }) => {
  return {
    '& .MuiSvgIcon-root': {
      color: theme.palette.separators.primary,
      backgroundColor: theme.palette.separators.primary,
      border: `${theme.palette.button.save.primary}`,
      borderRadius: '2px',
      height: '24px',
      width: '24px'
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      color: `${theme.palette.button.save.primary} `,
      borderColor: `${theme.palette.button.save.primary}`,
      borderRadius: '2px'
    }
  }
})

export const TableCellStyle = styled(Box)(() => {
  return {
    border: 'none',
    alignItems: 'center',
    fontSize: '14px',
    justifyContent: 'center',
    color: '#707079',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    minWidth: '200px',
    maxWidth: '200px',
    width: '200px'
  }
})

export const TooltipStyle = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, color }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 15,
    fontFamily: 'Nunito',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'capitalize',
    color
  }
}))

export const TypographyStyle = styled(Typography)(() => {
  return {
    color: '#707079',
    textAlign: 'center',
    leadingTrim: 'both',
    textEdge: 'cap',
    fontFamily: 'Nunito',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal'
  }
})
export const TypographyWidgetStyle = styled(Typography)(() => {
  return {
    marginLeft: '20px',
    paddingTop: '6px',
    color: '#FFF',
    fontFamily: 'Nunito',
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: '50'
  }
})
export const GridWidget = styled(Grid)(() => {
  return {
    borderTopRightRadius: '8px',
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    backgroundColor: '#39393C',
    marginBottom: '0px !important',
    height: '35px',
    display: 'flex',
    justifyContent: 'space-between'
  }
})

export const TradeBlotterTool = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  backgroundColor: '#242428',
  padding: '10px 8px'
}))

export const ContainerButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '12px'
}))

export const StyledMenu = styled(props => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    {...props}
  />
))(({ theme, style = {}, backgroundcolor = '#171719', backgroundColorHover }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    backgroundColor: backgroundcolor,
    marginTop: theme.spacing(1),
    minWidth: 180,
    ...style,
    color: theme.palette.text.primary,
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0'
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5)
      },
      '&:hover': {
        backgroundColor: backgroundColorHover || theme.palette.tabs.backgroundColor.hover
      }
    },
    '& .MuiList-root': {
      ...style,
      backgroundColor: 'transparent'
    }
  }
}))

export const IconButtonStyle = styled(IconButton)(({ theme, press }) => {
  let border = 'none'
  if (press === 'true') {
    border = `1px solid ${theme.palette.text.primary} `
  }

  return {
    display: 'flex',
    gap: '10px',
    border,
    height: '32px',
    borderRadius: '50%',
    backgroundColor: theme.palette.separators.primary,
    '&:hover': {
      backgroundColor: '#4F4F52s'
    }
  }
})

export const TextQuantity = styled(Typography)(({
  theme,
  quantity,
  color = 'white',
  opacity = 1
}) => {
  if (+quantity < 0) {
    color = theme.palette.price.down
  }
  return {
    color,
    opacity,
    fontFamily: 'Nunito',
    fontWeight: 500,
    fontSize: '14px',
    marginTop: '10px',
    marginBottom: '10px'
  }
})

export const DownloadComponentStyle = styled(DownloadComponent)({
  paddingTop: '15px'
})

export const CopyComponentStyle = styled(CopyComponent)({
  paddingTop: '15px'
})

export const InfoDealStatusComponentStyle = styled(InfoDealStatusComponent)({
  paddingTop: '15px'
})

export const TextPriceStyle = styled(Typography)(({ theme, status }) => {
  let color = `${theme.palette.price.same}`
  switch (status) {
    case STATUS_CURRENCY_PAIR.UP:
      color = `${theme.palette.price.up}`
      break
    case STATUS_CURRENCY_PAIR.DOWN:
      color = `${theme.palette.price.down}`
      break
    case STATUS_CURRENCY_PAIR.SAME:
      break
    default:
      break
  }
  return {
    color,
    leadingTrim: 'both',
    textEdge: 'cap',
    fontFamily: 'Nunito',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal'
  }
})

export const PriceContainer = styled(Box)(theme => ({
  display: 'flex',
  position: 'absolute',
  height: '100%',
  width: '100%',
  minWidth: '200px',
  maxWidth: '200px',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px'
}))

export const StyledMenu2 = styled(props => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    {...props}
  />
))(({ theme, style = {}, backgroundColor = '#171719' }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    backgroundColor: backgroundColor,
    marginTop: theme.spacing(1),
    minWidth: 180,
    ...style,
    color: theme.palette.text.primary,
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0'
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5)
      },
      '&:hover': {
        backgroundColor: theme.palette.tabs.backgroundColor.hover
      }
    },
    '& .MuiList-root': {
      ...style,
      backgroundColor: 'transparent'
    }
  }
}))

export const ContainerRatesWidget = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    marginTop: '50px'
  }
}))

export const ContainerTradeBlotterWidget = styled(Grid)({
  display: 'flex',
  flexDirection: 'column'
})

export const ContainerTradeBlotterAgGridTable = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 2,
  minHeight: '0px',
  [theme.breakpoints.between('xs', 'md')]: {
    marginBottom: '9rem'
  }
}))

export const ContainerRatesAgGridTable = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minHeight: '0px',
  [theme.breakpoints.between('xs', 'md')]: {
    marginBottom: '9rem'
  }
}))

export const ContainerActivityBlotterAgGridTable = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minHeight: '0px',
  [theme.breakpoints.between('xs', 'md')]: {
    marginBottom: '9rem'
  }
}))

export const ContainerBloomberg = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  position: 'fixed',
  zIndex: 1,
  bottom: '0%',
  marginTop: '100px',
  right: '0.2%'
})

export const ChipStyle = styled(Chip)({
  display: 'inline-flex',
  padding: '4px 8px 4px 16px',
  alignItems: 'center',
  gap: 8,
  borderRadius: '20px',
  backgroundColor: '#39393C',
  border: 'none !important',
  '&.MuiChip-root': {
    border: 'none !important'
  },
  '&.MuiChip-outlined': {
    border: 'none !important'
  }
})
